module.exports = __webpack_public_path__ + "assets/img/img-fv.c1b94cd7.jpg";